import { request } from '../request'
import type { PageResult, PortalNotice } from './types'

export const listNotices = (params: { page?: number; size?: number; type?: number } = {}) =>
  request<PageResult<PortalNotice>>('/api/portal/notices', { params })

export const latestNotices = (limit = 5) => request<PortalNotice[]>('/api/portal/notices/latest', { params: { limit } })

export const noticeDetail = (id: string) => request<PortalNotice>(`/api/portal/notices/detail/${id}`)
